import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";

export class GetPredictiveMaintenanceScheduleResData extends ApiGenericResponse {
    predictionScheduleTime: string = null;
    lastTrainingDate: Date = null;
    trainingScheduleDays: Number = null;
    trainingScheduleTime: string = null;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.PredictionScheduleTime) this.predictionScheduleTime = obj.PredictionScheduleTime;
        if (obj.LastTrainingDate) this.lastTrainingDate = obj.LastTrainingDate;
        if (obj.TrainingScheduleDays != null || obj.TrainingScheduleDays != undefined) this.trainingScheduleDays = obj.TrainingScheduleDays;
        if (obj.TrainingScheduleTime) this.trainingScheduleTime = obj.TrainingScheduleTime;
    }
}
